// bus.js 兄弟组件间传值中转站

import Vue from 'vue';
export default new Vue;